/* global attachEvent, Swiper */

// *******************************************************************************
// Open Timeline-nav in mobile
// *******************************************************************************
attachEvent('.timeline-list__nav__button', 'click', (ev) => {
  document.body.classList.toggle('is-open-timeline');
  ev.preventDefault();
});

// *******************************************************************************
// Scroll to next section
// *******************************************************************************
const navLinks = document.querySelectorAll('.timeline-list__nav li');

function removeNavClass(element) {
  navLinks.forEach((navLink) => {
    navLink.classList.remove('is-active');
  });
  element.classList.add('is-active');
}

const timelineSliderElements = document.querySelectorAll('[data-slider="timeline-slider"]');
const timelineSliderOptions = {
  direction: 'vertical',
  slidesPerView: 1,
  mousewheel: {
    releaseOnEdges: true,
  },
  speed: 800,
  hashNavigation: {
    watchState: true,
  },
  keyboard: {
    enabled: true,
  },
};

timelineSliderElements.forEach((el) => {
  // eslint-disable-next-line no-new
  const timelineSlider = new Swiper(el, timelineSliderOptions);

  timelineSlider.on('slideChange', () => {
    const activeSlideIndex = timelineSlider.realIndex;
    removeNavClass(navLinks[activeSlideIndex]);
  });
});
